function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKnowledgeSupportColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "09_Idea",
    id: "_09_Idea"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59,62H5a1,1,0,0,1-1-1V28a1,1,0,0,1,1-1H59a1,1,0,0,1,1,1V61A1,1,0,0,1,59,62Z",
    style: {
      fill: "#03a65a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,22H9a1,1,0,0,0-1,1V57a1,1,0,0,0,1,1H23.69A16.949,16.949,0,0,1,31,59.65q.255.1.51.24a1.03,1.03,0,0,0,.45.11.988.988,0,0,0,.45-.1l.21-.11c.12-.06.25-.12.38-.17A17.119,17.119,0,0,1,40.24,58H55a1,1,0,0,0,1-1V23A1,1,0,0,0,55,22Z",
    style: {
      fill: "#fdfeff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,39V59.62c-.13.05-.26.11-.38.17l-.21.11a.988.988,0,0,1-.45.1,1.03,1.03,0,0,1-.45-.11q-.255-.135-.51-.24V39Z",
    style: {
      fill: "#dfeaef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.515,61.579A15.179,15.179,0,0,1,40.237,60H55a3,3,0,0,0,3-3V27H57V57a2,2,0,0,1-2,2H40.237a16.183,16.183,0,0,0-7.168,1.684l-.216.107a2,2,0,0,1-1.8-.012A16.173,16.173,0,0,0,23.692,59H9a2,2,0,0,1-2-2V27H6V57a3,3,0,0,0,3,3H23.692a15.163,15.163,0,0,1,6.9,1.669A3.02,3.02,0,0,0,31.963,62a2.984,2.984,0,0,0,1.334-.313Z",
    style: {
      fill: "#c3d6dd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,57a1,1,0,0,1-1,1H40.237a17.189,17.189,0,0,0-7.613,1.788l-.216.107a.993.993,0,0,1-.445.1,1.006,1.006,0,0,1-.457-.11A17.164,17.164,0,0,0,23.692,58H9a1,1,0,0,1-1-1V26H7V57a2,2,0,0,0,2,2H23.692a16.173,16.173,0,0,1,7.357,1.779,2,2,0,0,0,1.8.012l.216-.107A16.183,16.183,0,0,1,40.237,59H55a2,2,0,0,0,2-2V26H56Z",
    style: {
      fill: "#dfeaef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,34a1,1,0,0,1-.555-.168L15,32.2l-2.445,1.63A1,1,0,0,1,11,33V22h8V33a1,1,0,0,1-1,1Z",
    style: {
      fill: "#d6e8f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,33a1,1,0,0,1-.555-.168L16,31.2l-2.445,1.63A1,1,0,0,1,12,32V22h8V32a1,1,0,0,1-1,1Z",
    style: {
      fill: "#f74e0c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,32V22H12V32a1,1,0,0,0,1.555.832l.563-.375A.986.986,0,0,1,14,32Z",
    style: {
      fill: "#e03a07"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#d6e8f2"
    },
    width: 15,
    x: 13,
    y: 38
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#d6e8f2"
    },
    width: 15,
    x: 13,
    y: 42
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#d6e8f2"
    },
    width: 15,
    x: 13,
    y: 46
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#d6e8f2"
    },
    width: 7,
    x: 13,
    y: 50
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#d6e8f2"
    },
    width: 15,
    x: 36,
    y: 38
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#d6e8f2"
    },
    width: 15,
    x: 36,
    y: 42
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#d6e8f2"
    },
    width: 15,
    x: 36,
    y: 46
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#d6e8f2"
    },
    width: 15,
    x: 36,
    y: 50
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#d6e8f2"
    },
    width: 2,
    x: 22,
    y: 50
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#d6e8f2"
    },
    width: 2,
    x: 26,
    y: 50
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    style: {
      fill: "#febc00"
    },
    width: 2,
    x: 31,
    y: 2
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    style: {
      fill: "#febc00"
    },
    transform: "translate(0.277 13.054) rotate(-29.998)",
    width: 2,
    x: 23.5,
    y: 4.009
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    style: {
      fill: "#febc00"
    },
    transform: "translate(-0.455 22.212) rotate(-59.998)",
    width: 2,
    x: 18.009,
    y: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#febc00"
    },
    width: 4,
    x: 15,
    y: 18
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#febc00"
    },
    width: 4,
    x: 45,
    y: 18
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#febc00"
    },
    transform: "translate(0.276 24.032) rotate(-29.995)",
    width: 4,
    x: 42.991,
    y: 10.5
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#febc00"
    },
    transform: "translate(14.548 37.215) rotate(-60.005)",
    width: 4,
    x: 37.5,
    y: 5.009
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,31v3.512a3.122,3.122,0,0,0,1.274,2.56,5.645,5.645,0,0,0,.552.341c.062.034.125.063.188.094.121.06.241.115.362.163.076.03.151.059.227.085.1.035.208.065.312.092.084.022.168.047.251.064s.149.022.223.033a4.168,4.168,0,0,0,.645.046c.031,0,.063,0,.094,0a3.746,3.746,0,0,0,.385-.033c.027,0,.053-.006.08-.011A4,4,0,0,0,35,34V30.576a9.834,9.834,0,0,1,2.7-6.571,8.917,8.917,0,0,0,1.344-2H22.937a9.049,9.049,0,0,0,1.437,2.091A10.148,10.148,0,0,1,27,31Z",
    style: {
      fill: "#d6e8f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,31H29a1,1,0,0,1-1-1,10.148,10.148,0,0,0-2.626-6.909,9,9,0,1,1,15.552-7.263h0A9.036,9.036,0,0,1,38.7,23.005,9.834,9.834,0,0,0,36,29.576V30A1,1,0,0,1,35,31Z",
    style: {
      fill: "#febc00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,30a10.148,10.148,0,0,0-2.626-6.909A8.989,8.989,0,0,1,33.04,8.059a9,9,0,0,0-7.666,15.032A10.148,10.148,0,0,1,28,30a1,1,0,0,0,1,1h2A1,1,0,0,1,30,30Z",
    style: {
      fill: "#edaa03"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,30H31V20a1,1,0,0,1,.293-.707l3-3,1.414,1.414L33,20.414Z",
    style: {
      fill: "#fdfeff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.389,
    style: {
      fill: "#fdfeff"
    },
    transform: "translate(-4.127 26.934) rotate(-45)",
    width: 2,
    x: 29.448,
    y: 16.254
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.274,36.072A3.122,3.122,0,0,1,28,33.512V29h8v4C36,36.078,32.506,38.356,29.274,36.072Z",
    style: {
      fill: "#f74e0c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.274,36.072A3.122,3.122,0,0,1,30,33.512V29H28v4.512a3.122,3.122,0,0,0,1.274,2.56,4.437,4.437,0,0,0,3.713.8A5.056,5.056,0,0,1,31.274,36.072Z",
    style: {
      fill: "#e03a07"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 25,
    r: 1,
    style: {
      fill: "#f74e0c"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledgeSupportColor);
export default __webpack_public_path__ + "static/media/knowledge_support_color.044c4e52c708fe170f820765b7424a07.svg";
export { ForwardRef as ReactComponent };